import {useMutation,useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {UserApiService} from 'features/users/api/user-api.service';
import {AddRole, SaveRolePrivilegePermissionsDTO, SaveUserPermissionsDTO, UpdateRole} from 'features/users/types' ;
const { saveUserRolePermissons,saveUserRole,saveUpdateRole,saveRolePrivilegePermissons  } = UserApiService();
export const useSaveUserRolePermissions = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: SaveUserPermissionsDTO) => {
      return saveUserRolePermissons(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['SaveUserRolePermissions'],
        });
         message.success('Successfully saved user role permissions.');
          
        
      },
    },
  );
};


export const useAddRole = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();
  
return useMutation(
    (payload: AddRole) => {
      return saveUserRole(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['roleTypeLists'],
        });
         message.success('Successfully saved user role.');
      },
    },
  );
};

export const useUpdateRole = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();
  
return useMutation(
    (payload: UpdateRole) => {
      return saveUpdateRole(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (user) => {
        
        queryClient.invalidateQueries({
          queryKey: ['roleTypeLists'],
        });
          if(user.res?.type==1){
             message.success('Successfully saved user role.');
          }else if(user.res?.type==2){
            message.success('Successfully deleted user role.');
          }
      },
    },
  );
};



export const useSaveRolePrivilegePermissions = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: SaveRolePrivilegePermissionsDTO) => {
      return saveRolePrivilegePermissons(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['SaveRolePrivilegePermissions'],
        });
         message.success('Successfully saved role privilege permissions.');
          
        
      },
    },
  );
};




